export const take = (array: any[], n: number) =>
    array && array.length ? array.slice(0, n) : [];

export const isArray = (possibleArray: any): boolean =>
    Array.isArray(possibleArray);

export const head = <T = any>(array: Array<T>) =>
    array && array.length ? array[0] : undefined;

export const includes = (array: any[], element: any) =>
    array && array.length ? array.indexOf(element) > -1 : false;

export const uniq = (array: any[]) => [...new Set(array)];

export const arrayHasContent = <T>(array: T[] | any): array is T[] => {
    return array && Array.isArray(array) && array.length > 0;
};

export const toMap =
    <
        TValue extends object,
        TKey extends keyof TValue,
        TProp extends TValue[TKey],
    >(
        property: TKey,
    ) =>
    (map: Map<TProp, TValue>, value: TValue) => {
        map.set(value[property] as TProp, value);
        return map;
    };
